import { render, staticRenderFns } from "./DialogSelectPriceWay.vue?vue&type=template&id=09815754&scoped=true&"
import script from "./DialogSelectPriceWay.vue?vue&type=script&lang=js&"
export * from "./DialogSelectPriceWay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09815754",
  null
  
)

export default component.exports